import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
toast.configure();
/**
 * @description function use for to get dashboard data
 * @param {*} params accepting object
 */
export const getSubDashboardData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/subdashboard`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) { 
            callback(response)
        } else if (response.code === 404) {
          toast.error(response.message);
          callback()
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback()
        }
      }
    );
  };
};






/**
 * @description function use for to update uploaded packets graph
 * @param {*} params accepting object
 */
export const getTotalPacketsPieChartData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/subdashboard/uploadedPackets`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};





/**
 * @description function use for to update uploaded files graph
 * @param {*} params accepting object
 */
export const getFilesGraphData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/subdashboard/uploadedFiles`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};


/**
 * @description function use for to edited files graph
 * @param {*} params accepting object
 */
export const getEditFilesGraphData = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/subdashboard/editedFiles`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};


/**
 * @description function use for to edited files graph
 * @param {*} params accepting object
 */
export const getDataCount = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/subdashboard/getDataCount`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback();
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback();
        }
      }
    );
  };
};





